const o=o=>o;export{o as noop};
